import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PorscheDesignSystemModule } from '@porsche-design-system/components-angular';

@Component({
  selector: 'opa-reload-button',
  imports: [PorscheDesignSystemModule],
  templateUrl: './reload-button.component.html',
  styleUrl: './reload-button.component.scss',
})
export class ReloadButtonComponent {
  @Input({ required: true }) label: string | undefined;
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() click = new EventEmitter<void>();
}
